import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkspaceLibraryDocument } from "components/manageWorkspaces/workspaceLibrary/workspaceLibrary.types";

interface IWorkspaceLibraryDocumentsState {
  documents: {
    [key: string]: IWorkspaceLibraryDocument[];
  };
}

const initialState: IWorkspaceLibraryDocumentsState = {
  documents: {},
};

export const workspaceLibraryDocumentsSlice = createSlice({
  name: "workspaceLibraryDocuments",
  initialState,
  reducers: {
    setLibraryDocumentsForKey: (
      state,
      action: PayloadAction<{
        key: string;
        documents: IWorkspaceLibraryDocument[];
      }>,
    ) => {
      const { key, documents } = action.payload;
      if (!state.documents[key]) {
        state.documents[key] = [];
      }
      state.documents[key] = documents;
    },
    addLibraryDocumentForKey: (
      state,
      action: PayloadAction<{
        key: string;
        document: IWorkspaceLibraryDocument;
      }>,
    ) => {
      const { key, document } = action.payload;
      if (!state.documents[key]) {
        state.documents[key] = [];
      }
      const exists = state.documents[key].some(
        (doc) => doc.filename === document.filename,
      );
      if (!exists) {
        state.documents[key].push(document);
      }
    },
    removeLibraryDocumentForKey: (
      state,
      action: PayloadAction<{ key: string; filename: string }>,
    ) => {
      const { key, filename } = action.payload;
      if (state.documents[key]) {
        state.documents[key] = state.documents[key].filter(
          (doc) => doc.filename !== filename,
        );
      }
    },
    clearLibraryDocumentsForKey: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      if (state.documents[key]) {
        state.documents[key] = [];
      }
    },
  },
});

export const {
  setLibraryDocumentsForKey,
  addLibraryDocumentForKey,
  removeLibraryDocumentForKey,
  clearLibraryDocumentsForKey,
} = workspaceLibraryDocumentsSlice.actions;

export default workspaceLibraryDocumentsSlice.reducer;
